import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-24 bg-white dark:bg-dark-2 px-4">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Images */}
          <div className="w-full lg:w-1/2 relative h-[300px] sm:h-[400px] lg:h-[500px]">
            <div className="absolute w-[200px] sm:w-[250px] md:w-[300px] h-[300px] sm:h-[350px] md:h-[400px] top-4 sm:top-10 left-0 z-10">
              <img src="/about-1/1.png" alt="Students" className="w-full h-full object-cover rounded-lg" />
            </div>
            <div className="absolute w-[150px] sm:w-[180px] md:w-[200px] h-[150px] sm:h-[180px] md:h-[200px] top-0 right-4 sm:right-8 z-20">
              <img src="/about-1/2.png" alt="Online" className="w-full h-full object-cover rounded-lg" />
            </div>
            <div className="absolute w-[150px] sm:w-[180px] md:w-[200px] h-[150px] sm:h-[180px] md:h-[200px] bottom-4 right-4 sm:right-8 z-30">
              <img src="/about-1/3.png" alt="Education" className="w-full h-full object-cover rounded-lg" />
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-1/2 lg:ml-8 xl:ml-12 mt-8 lg:mt-0">
            <h2 className="text-title text-dark-1 italic font-bold leading-tight">
              "Nous croyons qu’apprendre, c’est fabriquer."
            </h2>

            <p className="text-gray-600 dark:text-gray-300 mt-6 text-subtitle">
              NextMaker est une plateforme d’apprentissage hybride panafricaine qui permet à chacun — jeunes, étudiants et professionnels — de transformer ses idées en projets concrets.
            </p>

            <p className="text-gray-600 dark:text-gray-300 text-subtitle mt-4">
              Née dans l’esprit du fablab local IrokofabLab, notre plateforme connecte les apprenants à des parcours pratiques, des tuteurs internationaux et des labs physiques pour vivre une expérience d’apprentissage complète et collaborative.

            </p>

            <a href="https://app.gonextmaker.com/auth/signup">
              <button className="mt-6 md:mt-8 px-6 py-3 md:px-8 md:py-3 bg-red-4 text-white font-medium rounded-full
            hover:bg-white hover:text-red-4 transition duration-300 text-button border-2 border-red-4">
                Commencer à apprendre gratuitement
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;